import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setError, setLoading } from "../redux/slices/ui";
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { AUTH_EMAIL, PIN_LENGTH } from "../auth/authConstants";
import PinInput from "../components/ui/PinInput";
import Button from "../components/ui/Button";

const emptyPin = () => Array(PIN_LENGTH).fill("");

const ChangePin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentPin, setCurrentPin] = useState(emptyPin);
  const [newPin, setNewPin] = useState(emptyPin);
  const [confirmPin, setConfirmPin] = useState(emptyPin);
  const [shake, setShake] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const fail = (message) => {
    setShake(true);
    setTimeout(() => setShake(false), 500);
    dispatch(setError({ show: true, message }));
  };

  const handleSubmit = async () => {
    if (submitting) return;

    const currentPinString = currentPin.join("");
    const newPinString = newPin.join("");
    const confirmPinString = confirmPin.join("");

    if ([currentPinString, newPinString, confirmPinString].some((p) => p.length !== PIN_LENGTH)) {
      fail("Συμπληρώστε και τα τρία πεδία PIN.");
      return;
    }

    if (newPinString !== confirmPinString) {
      setNewPin(emptyPin());
      setConfirmPin(emptyPin());
      fail("Το νέο PIN και η επιβεβαίωση δεν ταιριάζουν.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    setSubmitting(true);
    dispatch(setLoading(true));
    try {
      const credential = EmailAuthProvider.credential(AUTH_EMAIL, currentPinString);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPinString);
      navigate("/");
    } catch (err) {
      setCurrentPin(emptyPin());
      fail("Λάθος τρέχον PIN ή η αλλαγή απέτυχε.");
    } finally {
      setSubmitting(false);
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-7 overflow-y-auto px-6 py-10">
      <div className="flex flex-col items-center gap-2">
        <h4 className="font-semibold text-brand-700">Τρέχον PIN</h4>
        <PinInput value={currentPin} onChange={setCurrentPin} shake={shake} />
      </div>
      <div className="flex flex-col items-center gap-2">
        <h4 className="font-semibold text-brand-700">Νέο PIN</h4>
        <PinInput value={newPin} onChange={setNewPin} shake={shake} />
      </div>
      <div className="flex flex-col items-center gap-2">
        <h4 className="font-semibold text-brand-700">Επιβεβαίωση</h4>
        <PinInput value={confirmPin} onChange={setConfirmPin} onComplete={handleSubmit} shake={shake} />
      </div>
      <Button onClick={handleSubmit} disabled={submitting} className="w-56">
        Αλλαγή PIN
      </Button>
    </div>
  );
};

export default ChangePin;
